import { render, staticRenderFns } from "./searchs.vue?vue&type=template&id=104290a5"
import script from "./searchs.vue?vue&type=script&lang=js"
export * from "./searchs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports